import client from './client';
import { PlatformApp } from '../types/index';

// Feature #384 (Epic #381): the module registry. The backend serialises
// snake_case verbatim and nothing converts it (CLAUDE.md "API case
// convention"), so this module maps by hand — convention 1, same shape as
// `api/companies.ts`: a `Raw*` interface for the wire, `mapApp` for
// responses, `toRawAppUpdate` for the one body we send.
interface RawApp {
  id: string;
  key: string;
  name: string;
  description?: string | null;
  is_enabled: boolean;
  is_toggleable: boolean;
  updated_at: string;
}

interface RawAppList {
  items: RawApp[];
}

const mapApp = (a: RawApp): PlatformApp => ({
  id: a.id,
  key: a.key,
  name: a.name,
  description: a.description ?? undefined,
  isEnabled: Boolean(a.is_enabled),
  isToggleable: Boolean(a.is_toggleable),
  updatedAt: a.updated_at ?? '',
});

const toRawAppUpdate = (data: { isEnabled: boolean }): Record<string, unknown> => ({
  is_enabled: data.isEnabled,
});

// Open to every signed-in user: the SPA reads it at boot to decide which
// module routes to render. Deliberately unpaginated on the backend.
export const getApps = async (): Promise<PlatformApp[]> => {
  const response = await client.get<RawAppList>('/apps');
  return (response.data?.items || []).map(mapApp);
};

// Platform admin only. 400 for a non-toggleable module, 404 for an unknown key.
export const updateApp = async (key: string, data: { isEnabled: boolean }): Promise<PlatformApp> => {
  const response = await client.patch<RawApp>(`/apps/${key}`, toRawAppUpdate(data));
  return mapApp(response.data);
};
